





































































































































import User from "@/store/entities/user";
import { Component, Vue } from "vue-property-decorator";
import Ajax from '../../..//lib/ajax';
@Component({})
export default class UserAdd extends Vue {
  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  user:User=new User();
  
  data() {
    return {
      title: "Preliminary report",
      email: "",
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },

      occupation: [],
      occupationItems: ["Mühendis", "Şef"], 
      

    };
  }
  
  async createUser(){
    await Ajax.post(
        '/api/services/app/User/Create',this.user
      );

      Vue.$toast.success("Kayıt Eklendi");
      this.closeDialog();

  }
  async created() {
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }

openFileInput() {
  const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;
  if (fileInput) {
    fileInput.click();
  }
}

handleFileChange(event) {
  const selectedFile = event.target.files[0];
  if (selectedFile) {
    // Resim seçildiğinde bu kod çalışır
    const imagePreview = this.$refs.imagePreview as HTMLImageElement | undefined;
    if (imagePreview) {
      // Seçilen resmi önizleme alanında göster
      const reader = new FileReader();
      reader.onload = (e) => {
        if (typeof e.target.result === 'string') {
          imagePreview.src = e.target.result;
        }
      };
      reader.readAsDataURL(selectedFile);
    }
  }
}
  
  }
